import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';
import useTranslate from '../../customHooks/useTranslate';

export default function SwitchInput({
    labelText,
    onChangeMethod,
    checked,
    ...restProps
}) {
    const labelTranslated = useTranslate(labelText);
    return (
        <FormControlLabel
            control={<Switch onChange={onChangeMethod} checked={checked} />}
            label={labelTranslated}
            {...restProps}
        />
    );
}
